import { Helmet } from "react-helmet-async";

const SITE_URL = "https://www.highwalllift.com";

const SEOHead = ({
  title = "Highwall Lift - Precision Panel Installation Equipment",
  description = "Transform your boom or scissor lift into a precision installation tool. The Highwall Lift-Hanger securely positions drywall, insulated metal panels, and architectural glass at height.",
  keywords = "highwall lift, panel installation, drywall hanger, boom lift attachment, scissor lift hanger, IMP installation",
  canonicalPath = "",
  ogType = "website",
  ogImage = "https://customer-assets.emergentagent.com/job_share-hub-46/artifacts/ujlxoadu_Boom%20Lift%20Hang.jpg",
  article = null
}) => {
  const fullUrl = `${SITE_URL}${canonicalPath}`;
  // Avoid duplicate "| Highwall Lift" suffix - only append if title doesn't already end with it
  const brandSuffix = "| Highwall Lift";
  const titleHasBrand = title.toLowerCase().includes("highwall lift");
  const fullTitle = canonicalPath === "" || titleHasBrand ? title : `${title} ${brandSuffix}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Highwall Lift" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />

      {/* Article-specific meta (for blog posts) */}
      {article && (
        <>
          <meta property="article:published_time" content={article.publishedDate} />
          <meta property="article:author" content={article.author} />
          <meta property="article:section" content={article.category} />
        </>
      )}

      {/* Schema.org structured data for articles */}
      {article && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BlogPosting",
            "headline": title,
            "description": description,
            "image": ogImage,
            "author": {
              "@type": "Organization",
              "name": article.author || "Highwall Lift Team"
            },
            "publisher": {
              "@type": "Organization",
              "name": "Highwall Lift",
              "logo": {
                "@type": "ImageObject",
                "url": `${SITE_URL}/logo.png`
              }
            },
            "datePublished": article.publishedDate,
            "dateModified": article.modifiedDate || article.publishedDate,
            "mainEntityOfPage": {
              "@type": "WebPage",
              "@id": fullUrl
            }
          })}
        </script>
      )}

      {/* Product schema for product pages */}
      {ogType === "product" && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            "name": title,
            "description": description,
            "image": ogImage,
            "brand": {
              "@type": "Brand",
              "name": "Highwall Lift"
            },
            "manufacturer": {
              "@type": "Organization",
              "name": "Highwall Lift"
            }
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEOHead;
